const initialState = '';

export default function logoReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
